import { useEffect, useState } from "react";
import { usePermissions } from "react-admin";
import permissions from "app/permissions";
import { checkPermission } from "server/security/utils";
import dataProvider from "server/dataProvider";
import { dormitoryRequests } from "api/dormitoryApi";
import { useNotifyError } from "utils/useNotifyError";
import { currentRoomLabel } from "./roomLabels";

export const useSourceRoomLabel = (sourceAccommodationId, enabled = false) => {
  const notifyError = useNotifyError();
  const { permissions: userPermissions } = usePermissions();
  const canPreview = checkPermission(userPermissions, permissions.canPreviewDormitoryAccommodations);
  const [label, setLabel] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLabel(null);
    if (!enabled || !sourceAccommodationId || !canPreview) {
      return;
    }

    const fetchSource = async () => {
      try {
        const { data } = await dataProvider.customRequest(
          dormitoryRequests.getAccommodationById(sourceAccommodationId),
          null,
          "GET",
        );
        if (!cancelled) setLabel(currentRoomLabel(data));
      } catch (err) {
        if (!cancelled) notifyError(err);
      }
    };

    fetchSource();
    return () => {
      cancelled = true;
    };
  }, [sourceAccommodationId, enabled, canPreview, notifyError]);

  return enabled && canPreview ? label : null;
};
